export const getEnvS3Name = (env: string) => {
    switch (env) {
        case 'me':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-1rxhvvuygvvo';
        case 'mepreprod':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-sp5ymj4ny7hz';
        case 'nmpreprod':
            return 'nmpreprodathenabuckets-nmpreprodathenainputbucket-cgeg10fi6rd9';
        case 'caresnmdpsprod':
            return 'caresnmdpsprodathenabuck-caresnmdpsprodathenainpu-vi9ad14v2839';
        case 'dev':
            return 'devathenabuckets-devathenainputbucketdf2eb022-owwaq0ac6ps';
        case 'dev2':
            return 'dev2athenabuckets-dev2athenainputbucketd15b5775-usywk88m108d';
        case 'demo':
            return 'demoathenabuckets-demoathenainputbucketaceab7bf-5b85kvyjrrea';
        case 'gapreprod':
            return 'mc-default-bucket-stack-mcdefaultbucketinputa9022d-g2dl2gifddgt';
        case 'staging':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-lw43h91pvk8a';
        case 'ga':
            return 'mc-default-bucket-stack-mcdefaultbucketinputa9022d-zudsapivll91';
        case 'mcsandbox1':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-zbszujtfts5b';
        case 'mcsandbox2':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-sdflpdslc2ls';
        case 'mcsandbox3':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-ecafx8vrmmwz';
        case 'ky':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-xlodkddzjhdn';
        case 'de':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-shblv1cinbru';
        case 'depreprod':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-bxzftdna82um';
        case 'kypreprod':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-b7mnb6t1bsyh';
        case 'wvpreprod':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-dn9ooom8mhbr';
        case 'wv':
            return 'mc-bucket-stack-mcdefaultbucketinput634d72c2-7enwm1pjtv37';
        default:
            return undefined;
    }
}

